import { createFileRoute } from '@tanstack/react-router';

import { guardPermitAdminRoute } from '../modules/Permits/permitAdminRouteGuard';
import { PermitGroupDetailsPage } from '../modules/Permits/PermitsAdminPage/PermitGroupDetails';
import { assertIds, toId } from '../modules/Permits/routeParams';

// A permit request is a full page like the customer record (86bc85juw), so it renders
// outside the /permitting list layout.
export const Route = createFileRoute('/permitting_/$permitGroupId')({
  component: PermitGroupDetailsPage,
  params: {
    parse: (params) => ({ permitGroupId: toId(params.permitGroupId) }),
    stringify: (params) => ({ permitGroupId: String(params.permitGroupId) }),
  },
  loader({ context, params }) {
    guardPermitAdminRoute(context.authContext.user);
    assertIds(params.permitGroupId);
  },
  head() {
    return {
      meta: [{ title: 'Permit request' }],
    };
  },
});
